import { DocumentBaseSaveModel } from "../../../documents/documentVersionTable/DocumentVersionTable.types.ts";

export interface CloseAuditSaveModel {
    closedReason?: LegalEntityAuditClosedReason;
    document?: DocumentBaseSaveModel;
    sendNotificationToContact: boolean;
}

export enum LegalEntityAuditClosedReason {
    DoesNotNeedToRespond = 0,
    DoesNotWantToRespond = 1,
    AuditOpinion = 2,
    Other = 3,
}
